/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_Status_AllInputs */

const id_staff_resellers_status_all = /** @type {(inputs: Staff_Resellers_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua status`)
};

const en_staff_resellers_status_all = /** @type {(inputs: Staff_Resellers_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All statuses`)
};

/**
* | output |
* | --- |
* | "All statuses" |
*
* @param {Staff_Resellers_Status_AllInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_status_all = /** @type {((inputs?: Staff_Resellers_Status_AllInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_Status_AllInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_status_all(inputs)
	return id_staff_resellers_status_all(inputs)
});